import React from "react";
import * as S from "./styles";
import { format, parseISO, isValid } from "date-fns";
import { pt } from "date-fns/locale";

// Helper: parseISO seguro que não quebra com datas inválidas
const safeParse = (dateStr) => {
  if (!dateStr || dateStr === "Invalid Date") return null;
  try {
    const parsed = parseISO(dateStr);
    return isValid(parsed) ? parsed : null;
  } catch {
    return null;
  }
};

// Helper: format seguro que retorna fallback se data inválida
const safeFormat = (dateStr, formatStr, options = {}) => {
  const parsed = safeParse(dateStr);
  return parsed ? format(parsed, formatStr, options) : "N/A";
};

const BusStep = ({ steps, departDate, departArrivalDate }) => {
    const hasDifferentArrivalDate = departDate !== departArrivalDate && departArrivalDate;

    return (
        <S.BusStep>
            <S.StepLabel>
                <span>
                    {safeFormat(departDate, "dd MMMM", { locale: pt })}
                </span>
                <span>
                    {hasDifferentArrivalDate && departArrivalDate && (
                        <span>{safeFormat(departArrivalDate, "dd MMMM", { locale: pt })}</span>
                    )}
                </span>
            </S.StepLabel>
            <div className="steps">
                <S.Steps className="step-left">
                    <div className="step" />
                </S.Steps>
                <div className="ligature" />
                <S.Steps className="step-right">
                    <div className="step" />
                </S.Steps>
            </div>
            <S.StepLabel>
                <span>{steps?.origin || "N/A"}</span>
                <span>{steps?.destiny || "N/A"}</span>
            </S.StepLabel>
        </S.BusStep>
    );
};

export default BusStep;
